<template>
    <div class="container-fluid">
        <div class="card">
            <div class="row">
                <div class="col-md-4 p-2"><h4 class="mx-3 mt-1">{{title}}</h4></div>

                <div class="col-md-8 mt-2">
                    <nav aria-label="breadcrumb">
                        <div class="d-flex justify-content-start justify-content-md-end mx-3">
                            <ol class="breadcrumb">
                                <li  v-for="navigation in navigations" class="breadcrumb-item" :class="navigation.active"  v-if="navigation.active !== 'active'">
                                    <a :href="navigation.url" >{{navigation.name}}</a>
                                </li>
                                <li v-for="navigation in navigations" class="breadcrumb-item" :class="navigation.active"  v-if="navigation.active === 'active'" >
                                   {{navigation.name}}
                                </li>
                            </ol>
                        </div>

                    </nav>
                </div>
            </div>
        </div>

    </div>


</template>

<script>
export default {
    name: "BreadCrumbComponent",
    props: ['title','navigations','auth_employees'],

    computed: {

    },

    mounted() {

    }
}
</script>

<style scoped>

</style>
